import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { auth } from '../../actions/auth'

const Form = () => {

  const dispatch = useDispatch()
  const { mode } = useParams()
  const organizations = useSelector((state) => state.organizations.list)
  const showOrgSelect = mode !== 'guk'

  const validationSchema = useMemo(
    () =>
      Yup.object({
        login: Yup.string().required('Обязательное поле'),
        password: Yup.string().required('Обязательное поле'),
        ...(showOrgSelect && {
          organizationId: Yup.string().required('Обязательное поле')
        })
      }),
    [showOrgSelect]
  )

  const submitForm = (values) => {
    const { login, password, organizationId } = values
    const orgId = mode === 'guk' ? '' : `${organizationId}|`
    const authString = `${mode}|${orgId}${login}:${password}`
    dispatch(auth(authString))
  }

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: {
      login: '',
      password: '',
      organizationId: ''
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: submitForm
  })

  const getInputClassName = (field) =>
    `w-full rounded-[10px] border border-solid bg-[#f9fafb] px-[1.25rem] py-[0.875rem] text-[1rem] sm:text-[1.125rem] lg:text-[1.25rem] sm:px-[1.5rem] sm:py-[1rem] text-[#111827] placeholder:text-[#d9d9d9] outline-none focus:border-[#0d9488] ${
      touched[field] && errors[field] ? 'border-[#ef4444]' : 'border-[#e5e7eb]'
    }`

  return (
    <form
        onSubmit={handleSubmit}
        className="flex w-full max-w-[30.688rem] flex-col items-center gap-[1.25rem] sm:gap-[1.5rem] rounded-[20px] border border-solid border-[#d9d9d9] bg-white p-[1.5rem] sm:p-[2rem] lg:p-[2.5rem]"
      >
        <h2 className="m-0 text-[1.25rem] sm:text-[1.5rem] font-semibold text-[#202020]">
          Авторизация
        </h2>

        {showOrgSelect && (
          <label className="flex w-full flex-col gap-[0.312rem]">
            <span className="text-[0.938rem] sm:text-[1rem] font-medium leading-[1.25rem] text-[#4b5563]">
              Организация
            </span>
            <select
              name="organizationId"
              value={values.organizationId}
              onChange={handleChange}
              onBlur={handleBlur}
              className={getInputClassName('organizationId')}
            >
              <option value="" disabled>
                Выберите организацию
              </option>
              {(organizations ?? []).map((org) => (
                <option key={org.idOrganization} value={org.idOrganization}>
                  {org.OrgName}
                </option>
              ))}
            </select>
            {touched.organizationId && errors.organizationId && (
              <span className="text-[0.812rem] sm:text-[0.875rem] text-[#ef4444]">{errors.organizationId}</span>
            )}
          </label>
        )}

        <label className="flex w-full flex-col gap-[0.312rem]">
          <span className="text-[0.938rem] sm:text-[1rem] font-medium leading-[1.25rem] text-[#4b5563]">
            Логин
          </span>
          <input
            type="text"
            name="login"
            value={values.login}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Введите логин"
            className={getInputClassName('login')}
          />
          {touched.login && errors.login && (
            <span className="text-[0.812rem] sm:text-[0.875rem] text-[#ef4444]">{errors.login}</span>
          )}
        </label>

        <label className="flex w-full flex-col gap-[0.312rem]">
          <span className="text-[0.938rem] sm:text-[1rem] font-medium leading-[1.25rem] text-[#4b5563]">
            Пароль
          </span>
          <input
            type="password"
            name="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Введите пароль"
            className={getInputClassName('password')}
          />
          {touched.password && errors.password && (
            <span className="text-[0.812rem] sm:text-[0.875rem] text-[#ef4444]">{errors.password}</span>
          )}
        </label>

        <button
          type="submit"
          className="w-full cursor-pointer rounded-[10px] bg-[#0d9488] px-[1.5rem] py-[0.875rem] sm:py-[1rem] text-[0.938rem] sm:text-[1rem] font-medium text-white transition-colors hover:bg-[#0b8278]"
        >
          Войти
        </button>
      </form>
  )
}

export default Form
